<app-dialog
  [headerLabel]="title"
  [dialogType]="dialogType"
  [primaryActionText]="'ACTION.DONE' | translate"
  [secondaryActionText]="'ACTION.CONTINUE_LATER' | translate"
  [primaryActionDisabled]="isFormNotCompleted$ | async"
  [hideCloseButton]="true"
  [preventCloseOnEsc]="true"
  [trackingObject]="trackingObject"
  [primaryActionTapped]="doneTapped"
  [primaryActionTrackingAdditionalProperties]="
    trackingAdditionalProperties$ | async
  "
  [secondaryActionTapped]="continueLaterTapped"
  (onPrimaryAction)="onConfirm()"
  (onSecondaryAction)="onCancel()"
>
  <div id="post-purchase-dialog" overflowShadow>
    <div class="content-wrapper">
      <div class="header">
        {{ header }}
      </div>

      <app-form-master
        *ngIf="form"
        [form]="form"
        (formChanges)="updateTrackingAdditionalProperties($event)"
      >
        <app-labeled-section
          class="section industry"
          [header]="'DIALOG.POST_PURCHASE.LABELED_SECTION.INDUSTRY' | translate"
        >
          <app-select-field
            class="industry-field"
            [hideLabel]="true"
            [placeholder]="'DIALOG.POST_PURCHASE.FIELDS.INDUSTRY' | translate"
            [formControl]="industryField"
            [values]="industryValues"
            [trackingObject]="trackingObject"
            [trackingTapped]="industryTapped"
            [trackingSelected]="industrySelected"
            fieldId="industry"
            (onSelectOption)="onSelectIndustry($event.value)"
          >
          </app-select-field>

          <app-multi-select-field
            class="sub-industry-field"
            [hideLabel]="true"
            [placeholder]="
              'DIALOG.POST_PURCHASE.FIELDS.SUB_INDUSTRY' | translate
            "
            [formControl]="subIndustryField"
            [values]="subIndustryValues$ | async"
            [trackingObject]="trackingObject"
            [trackingTapped]="subIndustryTapped"
            [trackingSelected]="subIndustrySelected"
            fieldId="sub_industry"
          >
          </app-multi-select-field>
        </app-labeled-section>

        <app-labeled-section
          class="section business-years"
          [header]="
            'DIALOG.POST_PURCHASE.LABELED_SECTION.BUSINESS_YEARS' | translate
          "
        >
          <div class="business-years-wrapper">
            <div
              *ngFor="let businessYear of businessYears; let pos = index"
              class="business-years-field-wrapper"
            >
              <app-radio-field
                class="business-years-field"
                [hideLabel]="true"
                [value]="businessYear.value"
                [fieldControl]="businessYearsField"
                [fieldId]="'business_year_' + pos"
                [trackingObject]="trackingObject"
                [trackingTapped]="businessYearsTapped"
                group="business_year"
              >
              </app-radio-field>

              <label
                class="business-years-label"
                [attr.for]="'business_year_' + pos"
              >
                {{ businessYear.key }}
              </label>
            </div>
          </div>
        </app-labeled-section>

        <app-labeled-section
          class="section employees"
          [header]="
            'DIALOG.POST_PURCHASE.LABELED_SECTION.EMPLOYEES' | translate
          "
        >
          <app-radio-field
            class="just-me-field"
            [label]="
              'DIALOG.POST_PURCHASE.FIELDS.EMPLOYEES.JUST_ME' | translate
            "
            [fieldControl]="employeesRadioField"
            [value]="EmployeesRadioEnum.just_me"
            [trackingObject]="trackingObject"
            [trackingTapped]="employeesRadioTapped"
            fieldId="employees_radio_1"
            group="employees_radio"
          >
          </app-radio-field>

          <div class="there-are-more-wrapper">
            <app-radio-field
              class="there-are-more-field"
              [label]="
                'DIALOG.POST_PURCHASE.FIELDS.EMPLOYEES.THERE_ARE_MORE'
                  | translate
              "
              [fieldControl]="employeesRadioField"
              [value]="EmployeesRadioEnum.there_are_more"
              [trackingObject]="trackingObject"
              [trackingTapped]="employeesRadioTapped"
              fieldId="employees_radio_2"
              group="employees_radio"
            >
            </app-radio-field>

            <app-select-field
              class="field there-are-more-options"
              [hideLabel]="true"
              [placeholder]="'ACTION.SELECT' | translate"
              [formControl]="employeesField"
              [values]="employeesOptions"
              [trackingObject]="trackingObject"
              [trackingTapped]="employeesDropdownTapped"
              [trackingSelected]="employeesDropdownSelected"
              fieldId="employees"
            >
            </app-select-field>
          </div>
        </app-labeled-section>

        <app-labeled-section
          class="section what-matters-most"
          [header]="
            'DIALOG.POST_PURCHASE.LABELED_SECTION.WHAT_MATTERS_MOST' | translate
          "
        >
          <app-radio-field
            *ngFor="
              let whatMattersMostOption of whatMattersMostOptions;
              let pos = index
            "
            class="what-matters-most-field"
            [label]="whatMattersMostOption.key"
            [value]="whatMattersMostOption.value"
            [fieldControl]="whatMattersMostField"
            [fieldId]="'what_matters_most_' + pos"
            [trackingObject]="trackingObject"
            [trackingTapped]="priorityRadioSelected"
            group="what_matters_most"
          >
          </app-radio-field>
        </app-labeled-section>
      </app-form-master>
    </div>
  </div>
</app-dialog>
